import { css } from "react-emotion/macro"
import { color, font, mq } from "../../styles/variables"

export const peopleSection = css`
  img {
    width: 90px;
    height: 90px;
  }

  > div:not(:last-of-type) {
    padding-bottom: 60px;
  }

  h3 {
    background-color: ${color.rgb.purple[1]};
    color: ${color.rgb.white[0]};
    font-size: 24px;
    font-family: ${font.family.cursive};
    font-weight: 400;
    text-transform: none;
    padding: 2px 0;
    margin-bottom: 30px;
  }

  h4 {
    text-transform: none;
    font-size: 18px;
  }

  .people-list {
    display: flex;
    flex-wrap: wrap;
  }

  .person {
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 30px;
    width: 100%;

    a {
      font-weight: 400;
    }

    img {
      margin-right: 10px;
    }

    ${mq.sm(css`
      width: calc(50% - 15px);

      &:not(:nth-of-type(even)) {
        margin-right: 30px;
      }
    `)};

    ${mq.lg(css`
      width: calc(33.333333333% - 20px);

      &:not(:nth-of-type(even)) {
        margin-right: 0;
      }

      &:nth-of-type(3n - 2),
      &:nth-of-type(3n - 1) {
        margin-right: 30px;
      }
    `)};
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/OurPeople/style.js